import { PropsWithChildren } from 'react'
import useEquipmentEventsSubscription from '../../../../pages/Equipment/events/equipment/useEquipmentEventsSubscription.ts'
import useMaintenanceEventsSubscriptions from '../../../../pages/Processes/Maintenance/events/useMaintenanceEventsSubscription.ts'
import useWsClientParametersSubscription from '../../../ws/useWsClientParametersSubscription.ts'
import useParameterGroupsEventsSubscriptions from '@/pages/Parameters/events/groups/useParameterGroupsEventsSubscription.ts'
import useEquipmentGroupsEventsSubscriptions from '@/pages/Equipment/events/groups/useGroupsEventsSubscription.ts'
import useOrganizationsEventsSubscriptions from '@/pages/Organizations/events/useOrganizationsEventsSubscription.ts'
import useUsersEventsSubscriptions from '@/pages/Users/events/useUsersEventsSubscription.ts'
import useParameterEventsSubscriptions from '@/pages/Parameters/events/parameter/useParameterEventsSubscriptions.ts'
import useMDMEventsSubscriptions from '@/pages/MDM/events/useMDMEventsSubscriptions.ts'
import useAlarmSituationsEventsSubscriptions from '@/pages/Processes/AlarmSituations/events/useAlarmSituationsEventsSubscription.ts'
import useDashboardsEventsSubscriptions from '@/pages/Dashboards/events/useDashboardsEventsSubscriptions.ts'
import useLibraryEventsSubscriptions from '@/pages/Library/events/useLibraryEventsSubscriptions.ts'

const EventsSubscriptionsProvider = (props: PropsWithChildren) => {
  useWsClientParametersSubscription()

  useAlarmSituationsEventsSubscriptions()
  useParameterEventsSubscriptions()
  useParameterGroupsEventsSubscriptions()
  useEquipmentEventsSubscription()
  useEquipmentGroupsEventsSubscriptions()
  useMaintenanceEventsSubscriptions()
  useOrganizationsEventsSubscriptions()
  useUsersEventsSubscriptions()
  useMDMEventsSubscriptions()
  useDashboardsEventsSubscriptions()
  useLibraryEventsSubscriptions()

  return <>{props.children}</>
}

export default EventsSubscriptionsProvider
